module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "forum-container"
  }, [(!_vm.editMode) ? [_c('router-link', {
    staticClass: "forum",
    attrs: {
      "to": ("/" + _vm.root + "/" + (_vm.category.stringUrl) + "/" + (_vm.forum.stringUrl))
    }
  }, [_c('div', {
    staticClass: "details"
  }, [_c('h3', [_vm._v("\n                    " + _vm._s(_vm.forum.title) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.forum.description))])]), _vm._v(" "), (_vm.forum.lastReply) ? _c('div', {
    staticClass: "last-reply"
  }, [_c('h4', [_vm._v("Last Reply")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.forum.lastReply)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_c('h4', [_vm._v(_vm._s(_vm.forum.views) + " Views")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.forum.totalThreads) + " Threads - " + _vm._s(_vm.forum.totalPosts) + " Posts")])])]), _vm._v(" "), _c('div', {
    staticClass: "moderator-controls"
  }, [_c('div', {
    staticClass: "control",
    on: {
      "click": function($event) {
        _vm.editMode = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-pencil-alt"
  })])])] : _vm._e(), _vm._v(" "), (_vm.editMode) ? [_c('div', {
    staticClass: "edit-forum-form"
  }, [(_vm.editForumErrorMessage) ? _c('div', {
    staticClass: "validation-messages error"
  }, [_vm._v(_vm._s(_vm.editForumErrorMessage))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editForumTitle),
      expression: "editForumTitle"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Forum Title"
    },
    domProps: {
      "value": (_vm.editForumTitle)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.editForumTitle = $event.target.value
      }, function($event) {
        _vm.editForumErrorMessage = ''
      }]
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editForumDescription),
      expression: "editForumDescription"
    }],
    domProps: {
      "value": (_vm.editForumDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editForumDescription = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        _vm.editMode = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.saveForum
    }
  }, [_vm._v("Save")])])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63a7f51e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/Forums/ForumsForumItem.vue
// module id = 880
// module chunks = 2